import { coreApi } from "../client";
import { PAYROLL_PREFERENCE } from "../endpoints";

export const getPayrollPreference = async () => {
  const res = await coreApi.post(PAYROLL_PREFERENCE.GET);
  return res.data;
};

export const savePayrollPreference = async (payload) => {
  const res = await coreApi.post(PAYROLL_PREFERENCE.SAVE, payload);
  return res.data;
};

export const getPayrollEmail = async (corporationID) => {
  const res = await coreApi.get(`${PAYROLL_PREFERENCE.PAYROLL_EMAIL}?corporationID=${corporationID}`);
  return res.data;
};